import React, {useEffect, useMemo, useState} from 'react';
import {connect, history} from 'umi';
import {Blank, Layout, StatusTip} from 'tea-component';
import LeftMenu from '@/pages/home/components/LeftMenu';
import type { IMenuResultDto } from '@dbl/services/global';
import '@dbl/assets/scss/utilities/index.scss';
import './index.scss';
// import '@/pages/dashboard/assets/scss/components/navigation/navigationHeader.scss';
import {parseUrlInfo, useDblIntl} from '@/pages/datalab/utils/utils';
import {DRILL_DOWN_PAGES, MENU_LIST, MENU_URLS} from '@dbl/core/global';
import {IS_GLOBAL} from '@/pages/home/_config/config';
import {
  DEMO_GAME_LIST,
  DEMO_PATHS,
  LOCAL_STROAGE_GAME_CODE_KEY,
  MINI_GAME_CODE,
  ORGANIZATION_FUN
} from '@dbl/core/global';
import {storage} from '@/utils/utils';
import {findGame} from '@/pages/datalab/models/datalab';
import LeftMenuCustomHeader from '../components/LeftMenu';
import PermissionNew from '@/pages/dashboard/components/NoPermissionNew';
import {fetchDateEvents} from "@dbl/core/global";
import { EntryDashboardPath } from '@dbl/core/global';

const { Body, Content } = Layout;

	
const Loading = () => <StatusTip className="dtd-layout-loading" status="loading" loadingText="loading..."/>;

const DatalabLayout = (props: any) => {
  const {
    // gameCode,
    userInfo,
    rawGameList,
    gameList,
    gameLoading,
    currentGame,
    userInfoLoading,
    dispatch,
    exploreGame,
    allPrivileges,
    privilegesLoading,
  } = props;

  const [sideRoutes, setSideRoutes] = useState([]);

  const gameCode = currentGame?.game_code;
  const { isEn } = useDblIntl();
  const { urlId, system, realPath } = parseUrlInfo(history.location.pathname);
  useEffect(() => {
    if (gameList.length < 1) {
      // 获取游戏列表
      props.dispatch({
        type: 'datalab/getGameList',
        payload: {
          pathname: history.location.pathname,
        },
      });
    }
    if (exploreGame.length < 1) {
      dispatch({
        type: 'exploreAnalysisGames/getExploreAnalysisGameList',
        payload: {
          gameCode,
        },
      });
    }
    // getCommonConfig({game_code: gameCode || urlId || getGameCodeFromLocal()});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // 初始化获取datalab系统config接口
    fetchDateEvents(gameCode, EntryDashboardPath.DatalabLayout);
  }, [gameCode]);

  useEffect(() => {
    if (urlId !== gameCode) {
      urlId &&
        dispatch({
          type: 'datalab/changeGame',
          payload: {
            gameCode: urlId,
          },
        });
      // 发起权限请求
      dispatch({
        type: 'privilegesConfig/getPrivilegesConfig',
        payload: {
          game_code: urlId || gameCode,
        },
      });
      setSideRoutes([]); // 菜单置空, 页面整体显示加载状态
      return;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[urlId, gameCode]);
	
  // 初始化game
  useEffect(() => {
    if (!userInfo || rawGameList?.length < 1) {
      return;
    }
  
    let gameList = [...rawGameList];
    const { userid: curUserId, organization = [] } = userInfo || {};
    // todo Global环境处理逻辑，屏蔽无权限的游戏, Funcom 屏蔽demo
    if (IS_GLOBAL) {
      // Funcom屏蔽demo
      // Funcom通过demo url 进入则不屏蔽
      if (organization.includes(ORGANIZATION_FUN) &&
      !DEMO_PATHS.some(path => history.location.pathname.includes(path))
      )
      {
        gameList = (gameList || []).filter(item => !DEMO_GAME_LIST.includes(item.game_code));
      }

      // 删除主版本无权限的游戏
      gameList = (gameList || []).filter(item => item?.is_access);
      // 过滤子版本无权限的游戏
      gameList = gameList.map((item) => {
        const { game_List: subGameList = [] } = item;
        return {
          ...item,
          game_List: subGameList.filter((subItem: any) => subItem?.is_access)
        };
      });
    }
    // 获取gamecode
		
    const { code, userId } = storage.getItem(LOCAL_STROAGE_GAME_CODE_KEY) || {};
    // 优先使用url中的gamecode，没有的话使用缓存
    const gameCode = urlId || (userId === curUserId && code);
    const currentGame = findGame(gameCode, gameList);
    const isValidCode = [...gameList, ...gameList.flatMap(item => item.game_List ? item.game_List : [])].find(item => item.game_code === urlId)?.game_code;
    storage.setItem(LOCAL_STROAGE_GAME_CODE_KEY, {
      userId: curUserId,
      code: currentGame?.game_code,
    });
    if (!MENU_URLS.includes(realPath) ||  !isValidCode ) {
      // 没有详细路径的情况, 包含了路由中的gamecode不存在的情况, 重定向到 Chat BI页面
      history.replace(`/${system}/${currentGame.game_code}/Home`);
      return;
    }
    props.dispatch({
      type: 'datalab/save',
      payload: {
        gameList,
        currentGame,
        gameCode: currentGame.game_code,
      },
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allPrivileges,rawGameList, userInfo, urlId,]);
  // 监控权限数据变化, 重新计算菜单
  useEffect(() => {
    if (gameLoading !== false || userInfoLoading !== false) return;
    let isRedirect = false;
    const newMenuList = [];
    const getSecondMenu = (list: IMenuResultDto[]) => {
      const newList = [];
      list.forEach((item) => {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const { id, name_zh, path, privileges = [] } = item;
        // 权限判断
        const isShow =
          privileges.some((priv) => allPrivileges?.includes(priv)) &&
          (name_zh === '探索分析' ? exploreGame?.includes(urlId) : true) &&
          (id === '25' ? MINI_GAME_CODE?.includes(urlId || '') : true);
        isShow &&
          newList.push({
            ...item,
            title: isEn ? item.name_en : item.name_zh,
            path: `${gameCode}/${path}` || '',
          });
        const paths = `/${realPath}`;
        (paths === path || DRILL_DOWN_PAGES[paths] === path) &&
          (isRedirect = !isShow); // 兼容下钻页面路径的权限校验
      });
      return newList;
    };
    if(allPrivileges?.length>1){
      MENU_LIST.forEach((item: IMenuResultDto) => {
        if (item.subMenus) {
          const subMenus = getSecondMenu(item.subMenus || []);
          subMenus &&
            subMenus.length > 0 &&
            newMenuList.push({
              ...item,
              subMenus,
              title: isEn ? item.name_en : item.name_zh,
              path: `${gameCode}/${item.path}` || '',
            });
        }else{
          newMenuList.push({
            ...item, 
            title: isEn ? item.name_en : item.name_zh,
            path: `${gameCode}/${item.path}` || '',
          });
        }
      });
      setSideRoutes(newMenuList);
    }
    // 需要每次刷新保存上次路由路径
    if (!realPath || isRedirect) {
      if(allPrivileges?.length>1){
        props.history.replace(`/datalab/${gameCode || urlId}${'/Home'}`);
        return;
      }
   
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allPrivileges, exploreGame, gameCode, isEn, urlId,gameLoading,userInfoLoading]);
  // loading 和 Error 状态
  const error = useMemo(() => {
    if (gameLoading !== false || userInfoLoading !== false || privilegesLoading !== false) {
      return <Loading />;
    }
    if(allPrivileges?.length<=1){
      return <PermissionNew  showButton={false}  message={
        isEn ? 'Sorry, you do not have permission to access this game. To request permission, please contact the following team members: sallyxue, v_blljli, or ivyyfchen.'  : '抱歉，您无权访问当前业务。如需申请权限，请联系以下团队成员：sallyxue、v_blljli 或 ivyyfchen。'
      } />;
    }
    if (!currentGame && realPath !== 'Home'  ) {
      return (
        <Blank
          theme='permission'
          description={
            isEn
              ? 'No game-related information was obtained. Please confirm whether you have permission for related games or related games~'
              : '未获取到游戏相关信息，请确认是否有相关游戏或者相关游戏的权限~'
          }
        />
      );
    }
    return null;
  }, [gameLoading, userInfoLoading, currentGame, realPath, isEn, allPrivileges?.length<1, privilegesLoading]);
  return (
    <>
      <Body className="layout__body dbl-layout-body">
        <LeftMenu
          menuList={sideRoutes}
          title={''}
          customHeaderElement={<LeftMenuCustomHeader />}
          isShowShrinkMenuTextBubble={true}
        />
        <Content>{error || props.children}</Content>
      </Body>
    </>
  );
};

export default connect((state: any) => {
  const { loading, datalab, home, exploreAnalysisGames, privilegesConfig } = state;
  return {
    gameCode: datalab.gameCode,
    userInfo: home.userInfo,
    currentGame: datalab.currentGame,
    rawGameList: datalab.rawGameList,
    gameList: datalab.gameList,
    gameLoading: loading.effects['datalab/getGameList'],
    userInfoLoading: loading.effects['home/getUserInfo'],
    exploreGame: exploreAnalysisGames.exploreGame,
    allPrivileges: privilegesConfig.allPrivileges,
    privilegesLoading: privilegesConfig.privilegesLoading
  };
})(DatalabLayout);
